module.exports = __webpack_public_path__ + "assets/img/landscape4enhance.9b8e613f.jpeg";